import { ActionTypes } from "../type";

const initialState ={
    branch:null
}

export const branchReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.BRANCH:
            return {...state,branch:action.payload}
        default:
            return state;
    }
}